// @flow
import env from '../../environment';
import {getCreator, postCreator, putCreator, deleteCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_PRODUCT_VARIANT_OPTIONS: `${env.baseApiUrl}/im/admin/product-variant-option`,
  SAVE_PRODUCT_VARIANT_OPTION: `${env.baseApiUrl}/im/admin/product-variant-option`,
  EDIT_PRODUCT_VARIANT_OPTION: `${env.baseApiUrl}/im/admin/product-variant-option/:id`,
  GET_PRODUCT_VARIANT_OPTION: `${env.baseApiUrl}/im/admin/product-variant-option/:id`,
  DELETE_PRODUCT_VARIANT_OPTION: `${env.baseApiUrl}/im/admin/product-variant-option/:id`,
});

export const saveProductVariantOptionApi = postCreator(
  endpoints.SAVE_PRODUCT_VARIANT_OPTION
);

export const getProductVariantOptionsApi = getCreator(
  endpoints.GET_PRODUCT_VARIANT_OPTIONS
);

export const getProductVariantOptionApi = getCreator(
  endpoints.GET_PRODUCT_VARIANT_OPTION
);

export const updateProductVariantOptionApi = putCreator(
  endpoints.GET_PRODUCT_VARIANT_OPTION
);

export const deleteProductVariantOptionApi = deleteCreator(
  endpoints.DELETE_PRODUCT_VARIANT_OPTION
);
